/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ScholarshipfileapprovalGeneralStatus202,
  PutApiV1ScholarshipfileapprovalGeneralStatus400,
  PutApiV1ScholarshipfileapprovalGeneralStatus401,
  PutApiV1ScholarshipfileapprovalGeneralStatus404,
  PutApiV1ScholarshipfileapprovalGeneralStatus500,
  PutApiV1ScholarshipfileapprovalGeneralStatusMutationRequest,
  PutApiV1ScholarshipfileapprovalGeneralStatusMutationResponse,
} from "../../types/scholarshipTypeFileApprovalController/PutApiV1ScholarshipfileapprovalGeneralStatus.ts";
import { updateScholarshipGeneralStatusRequestViewModelSchema } from "../updateScholarshipGeneralStatusRequestViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ScholarshipfileapprovalGeneralStatus202Schema =
  z.boolean() as unknown as ToZod<PutApiV1ScholarshipfileapprovalGeneralStatus202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ScholarshipfileapprovalGeneralStatus400Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalGeneralStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ScholarshipfileapprovalGeneralStatus401Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalGeneralStatus401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ScholarshipfileapprovalGeneralStatus404Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalGeneralStatus404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ScholarshipfileapprovalGeneralStatus500Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalGeneralStatus500>;

export const putApiV1ScholarshipfileapprovalGeneralStatusMutationRequestSchema =
  z.lazy(
    () => updateScholarshipGeneralStatusRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalGeneralStatusMutationRequest>;

export const putApiV1ScholarshipfileapprovalGeneralStatusMutationResponseSchema =
  z.lazy(
    () => putApiV1ScholarshipfileapprovalGeneralStatus202Schema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalGeneralStatusMutationResponse>;
